import styled from 'styled-components';

export const SSearchIcon = styled.div`
  height: 40px;
  min-height: 40px;
  width: 40px;

  margin-left: 20px;
  margin-bottom: 20px;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.colors.primaryBorder};
  cursor: pointer;
  font-size: 13.5px;
  color: ${({ theme }) => theme.colors.icon};

  &:hover {
    background-color: ${({ theme }) => theme.colors.primaryBackground};
  }
`;

export const SWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const SInput = styled.input`
  height: 40px;
  width: 100%;

  margin-left: 20px;
  margin-top: 20px;
  margin-right: 20px;
  margin-bottom: 20px;
  padding-left: 16px;
  padding-right: 30px;

  font-size: 12.5px;
  border-radius: 20px;
  border: 1px solid ${({ theme }) => theme.colors.icon};

  &:focus {
    outline: none;
  }
`;

export const SClearIcon = styled.i`
  width: 0;

  position: relative;
  right: 50px;

  font-size: 17px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.icon};
`;
